import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, ExternalLink } from '../../components';
import { SocialMediaLink } from '../PageBuilder/Primitives/Link/SocialMediaLink';
import { getFieldValue } from '../../util/fieldHelpers';

import css from './ProfilePage.module.css';

// Map field keys to social media platforms
const SOCIAL_MEDIA_MAPPING = {
  facebookProfile: 'facebook',
  instagramProfile: 'instagram',
  twitterProfile: 'twitter',
  linkedinProfile: 'linkedin',
  youtubeProfile: 'youtube',
  tiktokProfile: 'tiktok',
  pinterestProfile: 'pinterest',
};

const SectionSocialMediaMaybe = props => {
  const { publicData, metadata, userFieldConfig, intl } = props;

  if (!publicData || !userFieldConfig) {
    return null;
  }

  const socialMediaLinks = [];
  const websiteUrl = getFieldValue(publicData, 'website') || getFieldValue(metadata, 'website');

  // Collect social media links
  Object.entries(SOCIAL_MEDIA_MAPPING).forEach(([fieldKey, platform]) => {
    const url = getFieldValue(publicData, fieldKey) || getFieldValue(metadata, fieldKey);
    if (url) {
      socialMediaLinks.push({
        platform,
        url,
        fieldKey,
      });
    }
  });

  // If no website or social media links, don't render anything
  if (!websiteUrl && socialMediaLinks.length === 0) {
    return null;
  }

  return (
    <div className={css.sectionSocialMedia}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ProfilePage.socialMediaTitle" />
      </Heading>

      <div className={css.socialMediaContent}>
        {websiteUrl && (
          <div className={css.websiteLink}>
            <span className={css.socialMediaLabel}>
              <FormattedMessage id="ProfilePage.websiteLabel" />:
            </span>
            <ExternalLink href={websiteUrl} className={css.websiteUrl}>
              {websiteUrl}
            </ExternalLink>
          </div>
        )}

        {socialMediaLinks.length > 0 && (
          <div className={css.socialMediaLinks}>
            <span className={css.socialMediaLabel}>
              <FormattedMessage id="ProfilePage.socialMediaLabel" />:
            </span>
            <div className={css.socialMediaIcons}>
              {socialMediaLinks.map(({ platform, url, fieldKey }) => (
                <SocialMediaLink
                  key={fieldKey}
                  platform={platform}
                  href={url}
                  className={css.socialMediaIcon}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionSocialMediaMaybe;
